"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_11eo7bh20r() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SeeFilled.tsx";
  var hash = "569f7a0f0452799475f6a38e00f3a555c1e43b9a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SeeFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 50
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "569f7a0f0452799475f6a38e00f3a555c1e43b9a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_11eo7bh20r = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_11eo7bh20r();
var Icon = (cov_11eo7bh20r().s[0]++, {
  name: 'see-filled',
  svg: "<path d=\"M12.0001 14C13.1046 14 14.0001 13.1046 14.0001 12C14.0001 10.8954 13.1046 9.99998 12.0001 9.99998C10.8955 9.99998 10.0001 10.8954 10.0001 12C10.0001 13.1046 10.8955 14 12.0001 14Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.5505 6.32174C14.4676 3.39341 9.63252 3.38841 6.54351 6.31038L2.83271 9.8205C1.58146 11.0041 1.58148 12.9958 2.83276 14.1794L6.54394 17.6897C9.63304 20.6117 14.4681 20.6065 17.551 17.6781L21.2387 14.1752C22.4839 12.9924 22.4839 11.0076 21.2387 9.82487L17.5505 6.32174ZM12.0001 16C14.2092 16 16.0001 14.2091 16.0001 12C16.0001 9.79084 14.2092 7.99998 12.0001 7.99998C9.79091 7.99998 8.00005 9.79084 8.00005 12C8.00005 14.2091 9.79091 16 12.0001 16Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;